import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../custom-component/modal/modal.component';
import {
  getStaffDocumentUploadNoticeModalConfig,
  isStaffDocumentUploadNoticeConfirmed,
  StaffDocumentUploadNoticeContentVariant
} from '../constants/staff-document-upload-notice.util';

@Injectable({ providedIn: 'root' })
export class StaffDocumentUploadNoticeModalService {
  private static readonly modalOptions: NgbModalOptions = {
    size: 'md',
    centered: true,
    backdrop: 'static',
    keyboard: true,
    windowClass: 'lookup-staff-doc-modal'
  };

  constructor(private readonly modal: NgbModal) {}

  /**
   * Opens the shared "Document Upload Notice" modal and resolves to true only when the user confirms.
   * Uses the Personal-tab look (windowClass = lookup-staff-doc-modal) for consistent styling everywhere.
   */
  async open(params: { contentVariant: StaffDocumentUploadNoticeContentVariant }): Promise<boolean> {
    const modalRef = this.modal.open(ModalComponent, StaffDocumentUploadNoticeModalService.modalOptions);
    modalRef.componentInstance.modalConfig = getStaffDocumentUploadNoticeModalConfig({
      title: 'notice',
      contentVariant: params.contentVariant
    });

    try {
      const result: unknown = await modalRef.result;
      return isStaffDocumentUploadNoticeConfirmed(result);
    } catch {
      return false;
    }
  }
}

